<script lang="ts">
  import { Button } from "sveltestrap"
  import { connected, chainId, chainData, defaultEvmStores, selectedAccount, web3 } from "svelte-web3";
  import { coreContract, currentChainId, isWalletConnected } from "../stores/store"
  import { COREABI } from "../abis/core"
  import { CONFIG } from "../config"
  import {beforeUpdate} from "svelte";

  export let className: string;

  const Web3Modal = window.Web3Modal.default;
  const WalletConnectProvider = window.WalletConnectProvider.default;
  let web3Modal;
  let provider;

  let infuraId = CONFIG[$currentChainId].RPC_URL.split('/')[4];

  const connect = async () => {
    // if (web3Modal) web3Modal.clearCachedProvider()
    web3Modal = new Web3Modal({
      cacheProvider: true,
      providerOptions: {
        walletconnect: {
          package: WalletConnectProvider,
          options: { infuraId }
        },
      },
      disableInjectedProvider: false,
    })

    try {
      provider = await web3Modal.connect()
      await defaultEvmStores.setProvider(provider);

      if (!CONFIG.hasOwnProperty($chainId)) {
        alert('Pilgrim is not supported on current network. Please switch to Mainnet.');
        isWalletConnected.set('false')
        return;
      }
      const core = new $web3.eth.Contract(COREABI, CONFIG[$chainId].CORE_ADDRESS);
      coreContract.set(core);

      isWalletConnected.set('true');

    } catch (e) {
      console.log('wallet connect fail')
      isWalletConnected.set('false')
    }
  }

  beforeUpdate(async () => {
    if ($isWalletConnected == 'true') {
      await connect();
    }
  });

</script>

<Button class="{className}" on:click={connect}><slot/></Button>
